export default __webpack_public_path__ + "static/media/pediatrician.3134438d.jpg";